import { Money, MoneyCurrency } from '@booking-core/domain/value_objects/money.js';
import type {
  PricingInput,
  PricingStrategy,
} from '../pricing-strategy.js';

export interface FlatPerHourParams {
  /** TWD per hour, regardless of party size. */
  readonly amountPerHour: number;
}

/** 每場固定時薪。Total = amount × (min/60). partySize ignored. */
export class FlatPerHourStrategy implements PricingStrategy {
  constructor(private readonly params: FlatPerHourParams) {}

  quote(input: PricingInput): Money {
    void input.partySize;
    const raw = this.params.amountPerHour * (input.billableDurationMinutes / 60);
    return Money.of({ amount: Math.round(raw), currency: MoneyCurrency.TWD });
  }
}
